/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `BB_IMPORT` - BB_IMPORT
 *   * `CEPRO_IMPORT` - CEPRO_IMPORT
 *   * `INITIAL_IMPORT` - INITIAL_IMPORT
 *   * `DTM` - DTM
 *   * `DTM_KAD` - DTM_KAD
 *   * `GP` - GP
 *   * `CHECK` - CHECK
 *   * `DMVS_GAD_CHECK` - DMVS_GAD_CHECK
 *   * `DMVS_DTI` - DMVS_DTI
 *   * `DMVS_GAD` - DMVS_GAD
 * ```
 */
export const PrejimkaTypesEnum = {
  BB_IMPORT: 'BB_IMPORT',
  CEPRO_IMPORT: 'CEPRO_IMPORT',
  INITIAL_IMPORT: 'INITIAL_IMPORT',
  DTM: 'DTM',
  DTM_KAD: 'DTM_KAD',
  GP: 'GP',
  CHECK: 'CHECK',
  DMVS_GAD_CHECK: 'DMVS_GAD_CHECK',
  DMVS_DTI: 'DMVS_DTI',
  DMVS_GAD: 'DMVS_GAD',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PrejimkaTypesEnum = ValuesOf<typeof PrejimkaTypesEnum>;

export type PrejimkaTypesEnumRequest = PrejimkaTypesEnum;
export type PrejimkaTypesEnumResponse = PrejimkaTypesEnum;
